import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./ForgotPasswordPage.css";
import logo from "../assets/delgro_logo.png";
import login_icon from "../assets/login_icon.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import EmailInputComponent from "../components/EmailInputComponent";
import PasswordInputcomponent from "../components/PasswordInputComponent";
import LogicContext from "../Context/LogicContext";
import DelgroLogo from "../components/delgro_logo/DelgroLogo";
import Container from "../components/my-container/Container";

function ForgotPassword() {
  const logicContext = useContext(LogicContext);
  const [pageInformation, setPageInformation] = useState(
    " enter your email address"
  );
  const [email, setEmail] = useState("");
  const HOSTNAME = process.env.REACT_APP_API_BASEURL_GET;

  const [showOTPForm, setShowOTPForm] = useState(false);
  const [showNewPasswordField, setShowNewPasswordField] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [newPassword, setNewPassword] = useState(false);

  var queryProperties = {
    sql_ref_no: 3,
    user_name: "",
    login_applicatoin: 1,
    option: 1,
  };

  function submitOtp(event) {
    event.preventDefault();
    setShowOTPForm(false);
    setShowNewPasswordField(true);
    logicContext.showToast("success");
  }

  const getUserTypedEmail = (email) => {
    setEmail(email);
  };

  const getUserTypedpassword = (password) => {
    setNewPassword(password);
  };

  const getUserTypedConfirmpassword = (password) => {
    setNewPassword(password);
  };

  function handleUserEmailSubmit(event) {
    event.preventDefault();
    if (email === "") return toast.error("enter a valid email address.");
    queryProperties.user_name = email;

    axios
      .get(`${HOSTNAME}api/data/get`, {
        params: { jstring: JSON.stringify([queryProperties]) },
      })
      .then((res) => {
        const response = res.data[0];
        if (response?.message_id === 1) {
          setShowOTPForm(true);
          setPageInformation("Enter verification code");
        } else {
          toast.error(response?.message_text);
        }
      })
      .catch((err) => {
        logicContext.showAlert("connection failed", "error");
      });
  }

  return (
    <>
      <div className="bg-white min-h-screen">
        <Container>
          <div className="max-w-[1050px] mx-auto">
            <div className="pt-6 px-2 md:px-6">
              <DelgroLogo />
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-9 gap-10 items-center px-2 md:px-6">
              <div className="md:col-span-5 flex flex-col items-start">
                <h3 className="text-[min(5vw,25px)] font-extrabold text-gray-700  max-w-md">
                  You are about to enter a productive zone where the impossible
                  is possible
                </h3>
                <img
                  src={login_icon}
                  className="mt-6 w-full max-w-[370px] object-contain"
                  alt="banner"
                />
              </div>
              <div className="md:col-span-4 w-full max-w-md mx-auto">
                <h2 className="text-3xl font-bold text-gray-600 mb-2">
                  Forget Password,
                </h2>
                <p className="text-lg font-medium text-gray-700">
                  {pageInformation}
                </p>
                <form className="space-y-6">
                  <div className="">
                    <div>
                      {!showNewPasswordField && !showOTPForm ? (
                        <EmailInputComponent
                          emailOnchange={getUserTypedEmail}
                        />
                      ) : null}

                      {showOTPForm ? (
                        <div className="form-group login-page-group3 layout">
                          <label>verification code</label>
                          <input
                            type="number"
                            value={otpValue}
                            className="form-control"
                            placeholder="Enter otp"
                            onChange={(e) => setOtpValue(e.target.value)}
                          />
                        </div>
                      ) : null}
                    </div>

                    {showNewPasswordField ? (
                      <PasswordInputcomponent
                        passwordChange={getUserTypedpassword}
                      />
                    ) : null}

                    {showNewPasswordField ? (
                      <PasswordInputcomponent
                        passwordChange={getUserTypedConfirmpassword}
                      />
                    ) : null}

                    {!showNewPasswordField && !showOTPForm ? (
                      <div className="mt-10">
                        <button
                          type="submit"
                          className="w-full py-3 text-sm font-semibold tracking-wider rounded-md bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-all duration-300"
                          onClick={handleUserEmailSubmit}
                        >
                          SUBMIT EMAIL
                        </button>
                      </div>
                    ) : null}

                    {showOTPForm ? (
                      <div className="mt-10">
                        <button
                          onClick={submitOtp}
                          type="submit"
                          className="w-full py-3 text-sm font-semibold tracking-wider rounded-md bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-all duration-300"
                        >
                          SUBMIT OTP
                        </button>
                      </div>
                    ) : null}

                    {showNewPasswordField ? (
                      <div className="mt-10">
                        <button
                          type="submit"
                          className="w-full py-3 text-sm font-semibold tracking-wider rounded-md bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-all duration-300"
                        >
                          SUBMIT NEW PASSWORD
                        </button>
                      </div>
                    ) : null}

                    <div className="mt-4 mb-20 md:mb-0 flex items-center justify-center">
                      <Link to="/login">
                        <p className="w-fit text-base font-medium text-blue-600 hover:underline hover:underline-offset-2">
                          Back to Login
                        </p>
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default ForgotPassword;
